import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "@/redux/hooks";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
  requirePharmacyUser?: boolean;
}

export function ProtectedRoute({
  children,
  requireSuperAdmin = false,
  requirePharmacyUser = false,
}: ProtectedRouteProps) {
  const user = useAppSelector((state) => state.auth.user);
  const isSuperAdmin = user?.isAdmin;
  const isPharmacyUser = !user?.isAdmin;
  const location = useLocation();

  // If no user is logged in, redirect to login
  if (!user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // If super admin is required but user is not super admin
  if (requireSuperAdmin && !isSuperAdmin) {
    // Redirect pharmacy users to their dashboard
    return <Navigate to="/pharmacy/dashboard" replace />;
  }

  // If pharmacy user is required but user is not pharmacy user
  if (requirePharmacyUser && !isPharmacyUser) {
    // Redirect admin users to their dashboard
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
}
